import { addMinutes, format, isAfter, isBefore, parse, set, subMinutes } from 'date-fns';
import { Reservation } from '../reservation/common/ReservationInterfaces';

export const localizeClockHourAndMinuteSeparator = (time: string, language: string): string => {
  return language === 'et' ? time.replace(':', '.') : time;
};

export const getReservationSlotTime = (slotNumber: number): string => {
  const slotsStartTime = set(new Date(), { hours: 9, minutes: 0, seconds: 0, milliseconds: 0 });
  const slotMoment = addMinutes(slotsStartTime, 15 * (slotNumber - 1));
  return format(slotMoment, 'HH:mm');
};

export const isReservationTimeWithin15Minutes = (reservation: Reservation): boolean => {
  const reservationDateWithTime = getReservationDateWithTime(reservation);
  const now = new Date();
  const start = subMinutes(reservationDateWithTime, 15);
  const end = addMinutes(reservationDateWithTime, 15);
  return !isBefore(now, start) && !isAfter(now, end);
};

const getReservationDateWithTime = (reservation: Reservation): Date => {
  const dateWithMidnightTime: Date = parse(reservation.reservationDate, 'dd.MM.yyyy', new Date());
  const dateWithTimeSetToFirstTimeslotStart: Date = set(dateWithMidnightTime, { hours: 9, minutes: 0, seconds: 0, milliseconds: 0 });
  const minutesToReservationTimeslotStart: number = 15 * (reservation.slotNumber - 1);

  return addMinutes(dateWithTimeSetToFirstTimeslotStart, minutesToReservationTimeslotStart);
};
